module.exports = __webpack_public_path__ + "img/pczk02.db072420.png";